<div *ngIf="showArrow">
  <div #arrowdown class="arrow down "
     [ngClass]="{'down':!active||pointsDown, 'up':active||!pointsDown, 'active': active}">
</div>
<div [ngClass]="{'scroll-to-top-text':true,'active':active}" *ngIf="active||!pointsDown"
     [translate]="'eos-tv-shop-ii.lbl.scroll-to-top'"></div>
</div>
